import styled from "@emotion/styled";
import { Box, Slider, type TextFieldProps, Typography } from "@mui/material";
import { CurrencyCode } from "Infrastructure/Models/CurrencyCodes";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import type { JSX } from "react";
import { type Control, Controller, type FieldPath, type FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues> = Omit<TextFieldProps, "onChange"> & {
  readonly name: FieldPath<FormType>;
  readonly label?: string;
  readonly control: Control<FormType, object>;
  readonly labelEndAdornment?: JSX.Element;
  readonly min: number;
  readonly max: number;
  readonly onChange?: (value: number) => void;
};

const StyledSlider = styled(Slider)`
  & .MuiSlider-thumb {
    width: ${(props) => props.theme.spacing(6)};
    height: ${(props) => props.theme.spacing(6)};
  }

  & .MuiSlider-thumb::after {
    content: '';
    background: ${(props) => props.theme.colors.white}; 
    width: ${(props) => props.theme.spacing(4.8)};
    height: ${(props) => props.theme.spacing(4.8)};
  }
`;

const StyledLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FormSlider = <T extends object>({ control, name, min, max, disabled, onChange: propsOnChange }: Props<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => {
        return (
          <Box>
            <StyledSlider
              min={min}
              max={max}
              disabled={disabled}
              value={Number(value)}
              onChange={(_, value) => {
                onChange(value.toString());
                propsOnChange?.(value as number);
              }}
            />
            <StyledLabelWrapper>
              <Typography fontWeight={500} color="secondary" variant="body2">
                {formatCurrency(min, CurrencyCode.CZK)}
              </Typography>
              <Typography fontWeight={500} color="secondary" variant="body2">
                {formatCurrency(max, CurrencyCode.CZK)}
              </Typography>
            </StyledLabelWrapper>
          </Box>
        );
      }}
    />
  );
};
